export default {"src":"/_next/static/media/icon_member.1c19936c.svg","height":560,"width":560,"blurWidth":0,"blurHeight":0};